import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '',
        data: { title: 'Dashboard', icon: 'images/dashboard.svg' },
        loadComponent: () =>
          import('./features/dashboard/admin/admin.component').then(m => m.AdminComponent),
      },
      {
        path: 'mi-cuenta',
        data: { title: 'Mi Cuenta', icon: 'images/micuenta.svg' },
        loadComponent: () =>
          import('./features/dashboard/mi-cuenta/micuenta.component').then(m => m.MiCuentaComponent),
      },
      {
        path: 'administradores',
        data: { title: 'Administradores', icon: 'images/administradores.svg' },
        loadComponent: () =>
          import('./features/dashboard/administradores/administradores.component').then(m => m.AdministradoresComponent),
      },
      {
        path: 'empresas',
        data: { title: 'Gestor de Empresas', icon: 'images/empresas.svg' },
        loadComponent: () =>
          import('./features/dashboard/empresas/empresas.component').then(m => m.EmpresasComponent),
      },
      {
        path: 'unidades',
        data: { title: 'Unidades de Negocio', icon: 'images/unidades.svg' },
        loadComponent: () =>
          import('./features/dashboard/unidades/unidades.component').then(m => m.UnidadesComponent),
      },
      {
        path: 'productos',
        data: { title: 'Gestor de Productos', icon: 'images/producto.svg' },
        loadComponent: () =>
          import('./features/dashboard/productos/productos.component').then(m => m.ProductosComponent),
      },
      {
        path: 'asignar-unidad',
        data: { title: 'Asignar Unidad' },
        loadComponent: () =>
          import('./features/dashboard/asignar-unidad/asignar-unidad.component').then(m => m.AsignarUnidadComponent),
      },
      {
        path: 'usuarios',
        data: { title: 'Gestor de Usuarios', icon: 'images/usuarios.svg' },
        loadComponent: () =>
          import('./features/dashboard/usuarios/usuarios.component').then(m => m.UsuariosComponent),
      },
      {
        path: 'campanas',
        data: { title: 'Gestor de Campañas', icon: 'images/campaign.svg' },
        loadComponent: () =>
          import('./features/dashboard/campanas/campanas.component').then(m => m.CampanasComponent),
      },
      {
        path: 'maestros',
        data: { title: 'Admin. de Maestros - UTM', icon: 'images/maestros.svg' },
        loadComponent: () =>
          import('./features/dashboard/maestros/maestros.component').then(m => m.MaestrosComponent),
      },
      {
        path: 'maestros/traslado',
        data: { title: 'Trasladar Medium' },
        loadComponent: () =>
          import('./features/dashboard/traslado-medium/traslado-medium.component').then(m => m.TrasladoMediumComponent),
      },
      {
        path: 'edicion-utm',
        data: { title: 'Edición UTM', icon: 'images/edicionutm.svg' },
        loadComponent: () =>
          import('./features/dashboard/edicion-utm/edicion-utm.component').then(m => m.EdicionUtmComponent),
      },
      {
        path: 'historial-utm',
        data: { title: "Historial de UTM's", icon: 'images/historial.svg' },
        loadComponent: () =>
          import('./features/dashboard/historial-utm/historialutm.component').then(m => m.HistorialUtmComponent),
      },
      {
        path: 'reportes',
        data: { title: 'Reportes y Analytics' },
        loadComponent: () =>
          import('./features/dashboard/reportes/reportes.component').then(m => m.ReportesComponent),
      },
      {
        path: 'utm-builder',
        data: { title: 'UTM Builder' },
        loadComponent: () =>
          import('./features/dashboard/utm-builder/utmbuilder.component').then(m => m.UtmBuilderComponent),
      },
      {
        path: 'url-cortas',
        data: { title: 'URL Cortas' },
        loadComponent: () =>
          import('./features/dashboard/url-cortas/urlcortas.component').then(m => m.UrlCortasComponent),
      },
      {
        path: 'url-activas',
        data: { title: 'URL Activas' },
        loadComponent: () =>
          import('./features/dashboard/url-activas/urlactivas.component').then(m => m.UrlActivasComponent),
      },
      {
        path: 'historial-qr',
        data: { title: "Historial de QR's" },
        loadComponent: () =>
          import('./features/dashboard/historial-qr/historialqr.component').then(m => m.HistorialQrComponent),
      },
    ],
  },
];
